<template>
	<span class="app-spinner" />
</template>

<style scoped lang="scss">
.app-spinner {
	width: 16px;
	height: 16px;
	border: 2px solid currentColor;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;

	animation: rotation 1s linear infinite;

	&.center {
		position: absolute;
		left: 50%;
		top: 50%;
		animation: rotation-center 1s linear infinite;
		transform: translate(-50%, -50%);
	}
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

@keyframes rotation-center {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}

	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}
</style>
